// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgDeleteIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M17.986 20.166A2 2 0 0 1 15.993 22H8.007a2 2 0 0 1-1.993-1.834L5 8h14zM20 4a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2h4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2z" />
  </g>
);
export default SvgDeleteIcon;
SvgDeleteIcon.displayName = 'SvgDeleteIcon';
